import { InboxClearIllustration } from 'src/components/InboxClearIllustration/inbox-clear-illustration';
import {
  Heading,
  INBOX_CLEAR_STATE_TEST_ID,
  Kicker,
  Stage,
  Subtitle,
} from './inbox-clear-state.styles';

export const InboxClearState = () => (
  <Stage data-testid={INBOX_CLEAR_STATE_TEST_ID}>
    <InboxClearIllustration size="page" />
    <Kicker>ALL CLEAR</Kicker>
    <Heading>That&apos;s everything.</Heading>
    <Subtitle>
      Every notification, handled. Nice work. We&apos;ll let you know the moment something new
      comes in.
    </Subtitle>
  </Stage>
);
